@if (typeSearch !== "backoffice" && typeSearch !== "backoffice-mini") {
  <label class="search-input-wrapper">
    <i class="material-icons search-icon" (click)="toggleSearchInput()">search</i>
    <input [ngClass]="{ toggled: isToggled }" (input)="filterFilled(condition)" [(ngModel)]="condition" class="search-input" type="text" #searchInput />
    <i [ngClass]="{ toggled: isToggled }" class="material-icons cross-icon" (click)="clearFilter()">clear</i>
  </label>
}

@if (typeSearch === "backoffice" || typeSearch === "backoffice-mini") {
  <label [ngClass]="typeSearch" class="search-input-wrapper">
    <i class="material-icons search-icon" (click)="toggleSearchInput()">search</i>
    <input
      [ngClass]="{ toggled: isToggled }"
      (input)="filterFilled(condition)"
      [(ngModel)]="condition"
      (click)="toggleSearchInput()"
      class="search-input"
      type="text"
      #searchInput />
    @if (typeSearch !== "backoffice-mini") {
      <i [ngClass]="{ toggled: isToggled }" class="material-icons cross-icon" (click)="clearFilter($event)">clear</i>
    }
    <div class="header-input">{{ "generic.search" | translate }}</div>
  </label>
}
